import { useProjectEditorsRealtime } from '@forgd/app-layer-core/layers/auth/composables/useProjectEditorsRealtime'

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }
  if (to.path.startsWith('/academy') || to.path.startsWith('/public')) {
    return
  }
  const auth = useAuth()
  const projectEditors = useProjectEditors()
  const projectEditorsRealtime = useProjectEditorsRealtime()

  // Wait for auth to be fully loaded
  await auth.waitForAuth({ from: 'project-realtime middleware' })

  // Wait for project editors data to be loaded if we have a selected project
  if (!projectEditors.isInitialized) {
    await projectEditors.initializeFromApi()
  }

  const isOwnerOrEditor = auth.project?.isAdvised && (auth.isOrganizationOwner || projectEditors.canRequestEdit)
  // Only advisors and organization owners with advised projects can subscribe to project realtime
  if (!auth.isAdvisor && !isOwnerOrEditor) {
    return
  }

  const isProjectRoute = to.path.startsWith('/project/') && to.params.projectId

  // Disable realtime subscriptions for non-project routes
  // (presence has its own lifecycle in useProjectPresence)
  if (!isProjectRoute) {
    projectEditorsRealtime.unsubscribe()
    return
  }

  const routeProjectId = to.params.projectId
  const projectId = (Array.isArray(routeProjectId) ? routeProjectId[0] : routeProjectId) ?? auth.selectedProjectId

  if (!projectId || !auth.me?.id) {
    return
  }

  projectEditorsRealtime.subscribeToProject(projectId, auth.me.id)
})
